import { Component, Input, OnChanges } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'era-active-device-syncs-progress-bar-ui',
  templateUrl: './active-device-syncs-progress-bar.component.html',
  styleUrls: ['./active-device-syncs-progress-bar.component.scss'],
  imports: [NgbTooltip],
})
export class ActiveDeviceSyncsProgressBarComponent implements OnChanges {
  @Input() maximumActiveDeviceSyncs: number;
  @Input() currentActiveDeviceSyncs: number;

  activeDeviceSyncsPercentage: number;

  ngOnChanges() {
    this.activeDeviceSyncsPercentage = (this.currentActiveDeviceSyncs / this.maximumActiveDeviceSyncs) * 100;
  }
}
